import React from "react";
import { School, SCHOOL_COLORS } from "../../../../util/cardEffects/effectTypes.ts";
import { useCardScale } from "../../../../util/cardUtils.ts";

interface UIButtonProps {
    x: number;
    y: number;
    onClick: () => void;
    scale?: number;
    children: React.ReactNode;
    school: School;
    inline?: boolean;
}

export const BUTTON_WIDTH = 150;
export const BUTTON_HEIGHT = BUTTON_WIDTH / 2;

export const UIButton: React.FC<UIButtonProps> = ({
    x,
    y,
    onClick,
    scale = 1,
    children,
    school,
    inline = true,
}) => {
    const schoolColor = SCHOOL_COLORS[school];
    const baseScale = useCardScale();

    const modifiedScale = baseScale * scale;


    return (
        <div style={{
            width: `${Math.ceil(BUTTON_WIDTH * modifiedScale)}px`,
            height: `${BUTTON_HEIGHT * modifiedScale}px`,
            overflow: "hidden",
            display: inline ? "inline-block" : "",
            borderRadius: `${8 * modifiedScale}px`
        }}>
            <button
                onClick={onClick}
                style={{
                    transformOrigin: "top left",
                    transform: `scale(${modifiedScale})`,
                    position: "absolute",
                    left: `${x}px`,
                    top: `${y}px`,
                    width: `${BUTTON_WIDTH}px`,
                    height: `${BUTTON_HEIGHT}px`,
                    borderRadius: `8px`,
                    backgroundColor: "#374151",
                    border: `2px solid ${schoolColor}`,
                    color: "#e5e7eb",
                    fontSize: `24px`,
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    padding: `4px`,
                    paddingTop: `14px`,
                    transition: "background-color 0.15s ease",

                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#4b5563";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#374151";
                }}
                onMouseDown={(e) => {
                    e.currentTarget.style.backgroundColor = "#1f2937";
                }}
                onMouseUp={(e) => {
                    e.currentTarget.style.backgroundColor = "#4b5563";
                }}
            >
                {children}
            </button>
        </div>
    );
};